import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../src/core/api/axiosClient";

const initialState: any = {
  tests: [],
  isLoadingTests: false,
  sensors: [],
  isLoadingSensors: false,
  testTypes: [],
  isLoadingTestTypes: false,
  testDetails: {},
  isLoadingTestDetails: false,
  filter: {},
  scheduleFilter: {},
  isLoading: false,
  error: null,
};

export const getTests: any = createAsyncThunk(
  "content/getTests",
  async ({
    PageNumber,
    pageSize,
    tcCode = null,
    siteCode = null,
    blockCode = null,
    SortBy,
    SortDirection,
  }: any) => {
    const res = await axios.get(
      `/slpapp/TestConfiguration/getTestConfigurationsByLocation`,
      {
        params: {
          PageNumber,
          pageSize,
          tcCode,
          siteCode,
          blockCode,
          SortBy,
          SortDirection,
        },
      }
    );

    const data = await res.data;
    return data;
  }
);

export const getSensors: any = createAsyncThunk(
  "content/getSensors",
  async ({
    PageNumber,
    pageSize,
    tcCode = null,
    siteCode = null,
    blockCode = null,
    testTypeId = null,
    SortBy,
    SortDirection,
  }: any) => {
    const res = await axios.get(
      `/slpapp/TestConfiguration/getSensorsByLocation`,
      {
        params: {
          PageNumber,
          pageSize,
          tcCode,
          siteCode,
          blockCode,
          testTypeId,
          SortBy,
          SortDirection,
        },
      }
    );

    const data = await res.data;
    return data;
  }
);

export const getTestById: any = createAsyncThunk(
  "content/getTestById",
  async ({ testConfigurationId }: any) => {
    const res = await axios.get(
      `/slpapp/TestConfiguration/TestConfigurationsById`,
      {
        params: { testConfigurationId },
      }
    );

    const data = await res?.data?.data;
    return data;
  }
);

export const deleteTest: any = createAsyncThunk(
  "content/deleteTest",
  async ({ testConfigurationId }: any) => {
    const res = await axios.delete(`/slpapp/TestConfiguration`, {
      params: { testConfigurationId },
    });

    const data = await res?.data;
    return data;
  }
);

export const getTestTypes: any = createAsyncThunk(
  "content/getTestTypes",
  async () => {
    const res = await axios.get(`/slpapp/TestType`);

    const data = await res.data;
    return data;
  }
);

export const addNewSchedule: any = createAsyncThunk(
  "content/addNewSchedule",
  async ({ payload }: any) => {
    const res = await axios.post(`/slpapp/TestConfiguration`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await res.data;
    return data;
  }
);

export const sendLightTestScheduleToDevice: any = createAsyncThunk(
  "content/sendLightTestScheduleToDevice",
  async ({ payload, testTypeId }: any) => {
    const res = await axios.post(
      `/slpapp/TestConfiguration/sendLightTestScheduleToDevice`,
      {},
      {
        params: { assetCode: payload, testTypeId },
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    const data = await res.data;
    return data;
  }
);

export const testSlice = createSlice({
  name: "test",
  initialState,
  reducers: {
    setFilter(state, action) {
      state.filter = action.payload;
    },
    setScheduleFilter(state, action) {
      state.scheduleFilter = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getTests.pending, (state) => {
      state.isLoadingTests = true;
    });
    builder.addCase(getTests.fulfilled, (state, action) => {
      state.isLoadingTests = false;
      state.tests = action.payload;
    });
    builder.addCase(getTests.rejected, (state, action) => {
      state.isLoadingTests = false;
      state.error = action.error.message;
    });

    builder.addCase(getTestById.pending, (state) => {
      state.isLoadingTestDetails = true;
    });
    builder.addCase(getTestById.fulfilled, (state, action) => {
      state.isLoadingTestDetails = false;
      state.testDetails = action.payload;
    });
    builder.addCase(getTestById.rejected, (state, action) => {
      state.isLoadingTestDetails = false;
      state.error = action.error.message;
    });

    builder.addCase(getSensors.pending, (state) => {
      state.isLoadingSensors = true;
    });
    builder.addCase(getSensors.fulfilled, (state, action) => {
      state.isLoadingSensors = false;
      state.sensors = action.payload;
    });
    builder.addCase(getSensors.rejected, (state, action) => {
      state.isLoadingSensors = false;
      state.error = action.error.message;
    });

    builder.addCase(deleteTest.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(deleteTest.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(deleteTest.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });

    builder.addCase(getTestTypes.pending, (state) => {
      state.isLoadingTestTypes = true;
    });
    builder.addCase(getTestTypes.fulfilled, (state, action) => {
      state.isLoadingTestTypes = false;
      state.testTypes = action.payload;
    });
    builder.addCase(getTestTypes.rejected, (state, action) => {
      state.isLoadingTestTypes = false;
      state.error = action.error.message;
    });

    builder.addCase(addNewSchedule.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(addNewSchedule.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(addNewSchedule.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.error.message;
    });
  },
});

export const { setFilter, setScheduleFilter } = testSlice.actions;

export default testSlice.reducer;
